import { Injectable } from '@angular/core';
import { catchError, delay, debounceTime, filter, map, switchMap, tap, share } from 'rxjs/operators';
import { ProfileStore } from './profile.store';
import { ApiService } from '@patientlynk3/services/api/api.service';
import { AuthService } from '@patientlynk3/services/auth/auth.service';
import { Logger } from '@patientlynk3/services/logger/logger.service';
import { ProfileQuery } from '@patientlynk3/services/profile/profile.query';
import { Observable, Subject, of } from 'rxjs';
import { Profile } from '@patientlynk3/models/profile.model';


@Injectable({ providedIn: 'root' })
export class ProfileService {

  $testprofile = new Subject<Profile>

  constructor(private store: ProfileStore, private query: ProfileQuery,
              private auth: AuthService, private api: ApiService) {
                // this.$testprofile.subscribe((data) => {
                //   console.log("this.$testprofile", data);
                // })

                // setInterval(() =>{
                //   let newItem = {name:"new Value", number: Math.random()}
                //   this.$testprofile.next(newItem)
                // }, 5000);

    this.auth.isLoggedIn$.pipe(
      filter(isLoggedIn => !isLoggedIn),
    ).subscribe(() => this.reset());
  }

  get$ = this.auth.isLoggedIn$.pipe(
    filter(isLoggedIn => !!isLoggedIn),
    switchMap(() => this.query.selectHasCache()),
    switchMap(hasCache => hasCache ? this.query.select() : this.getNewProfile$),
  );

  private getNewProfile$ = of(true).pipe(
    debounceTime(1000),
    switchMap(() => this.api.getProfile()),
    share(),
    tap(() => this.store.setError(null)),
    catchError(error => {
      Logger.error('Error retrieving patientLynk profile data.', error);
      this.store.setError('Could not retrieve data. Reverting to previous snapshot.');
      return this.query.select();
    }),
    map(profile => new Profile(profile)),
    tap(profile => {      
      console.log("profileChanges", profile);
      this.$testprofile.next(profile)

      this.store.update(profile)
    }),
    tap(
      () => this.store.setHasCache(true),
      () => this.store.setHasCache(false)
    ),
    tap(profile => {      
      this.analyticsIdentify(profile)
    }),
  );

  reset() {
    window['Sentry']?.configureScope(scope => scope.setUser(null));
    window['hj']?.('identify', null);

    this.store.reset();
    this.store.setHasCache(false);
    return of({});
  }

  update(profileChanges: Partial<Profile>) {
    profileChanges = new Profile(profileChanges);
    return this.store.update({ ...profileChanges });
  }

  getValue() {
    return this.query.getValue();
  }

  refresh() {
    of(true).pipe(
      delay(2 * 1000),
      switchMap(() => this.auth.getDataBases())
    ).subscribe(() => this.store.setHasCache(false));
  }

  private analyticsIdentify(profile: Partial<Profile>) {
    const fullName = profile.first_name + ' ' + profile.last_name;
    const primaryEmail = profile.emails?.find(email => email.primary)?.[0];

    window['Sentry']?.setUser({
      id: profile.id,
      email: primaryEmail,
      username: fullName
    });

    window['hj']?.('identify', profile.id, {
      email: primaryEmail,
      name: fullName
    });
  }
}
